import { render, staticRenderFns } from "./CreateInternet.vue?vue&type=template&id=30c00fae"
import script from "./CreateInternet.vue?vue&type=script&lang=js"
export * from "./CreateInternet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports